<template>
  <div v-if="hasAds" class="text-center pb-2 ads-wrapper">
    <ins
      class="adsbygoogle"
      style="display: block"
      :data-ad-client=adClient
      :data-ad-slot=adSlot
      data-ad-format="auto"
      data-adtest="on"
      data-full-width-responsive="true"
    ></ins>
  </div>
</template>

<script>
import {mapState} from 'vuex';
import {USER_CAPABILITY} from '@/const';

export default {
  name: 'AdsenseBlock',
  props: {
    adClient: {
      type: String,
      required: true,
    },
    adSlot: {
      type: String,
      required: true,
    },
  },
  data() {
    return {
      externalLoaded: false,
    };
  },
  computed: {
    ...mapState({
      channelSettings: (state) => state.channel.settings,
      capabilities: (state) => state.auth.capabilities,
    }),
    hasAds() {
      return !!this.channelSettings?.has_ads && !this.capabilities[USER_CAPABILITY.no_ads];
    },
  },
  metaInfo() {
    return {
      script: [
        {
          skip: !this.hasAds,
          vmid: 'adsbygoogle',
          src: '//pagead2.googlesyndication.com/pagead/js/adsbygoogle.js',
          crossorigin: 'anonymous',
          async: true,
          dataAdClient: this.adClient,
          callback: () => (this.externalLoaded = true),
          id: 'testId',
        },
        {
          skip: !this.hasAds,
          vmid: 'adsbygoogle-push',
          innerHTML: '(adsbygoogle = window.adsbygoogle || []).push({});',
        },
      ],
      __dangerouslyDisableSanitizersByTagID: {
        'adsbygoogle-push': ['innerHTML'],
      },
    };
  },

};
</script>

<style scoped>
.ad-style-legend {
  color: #9d9c9c;
  font-size: 12px;
}
.ads-wrapper {
  overflow: hidden;
}
</style>
